export interface User {
  id: number;
  email: string;
  company: number;
  type: UserType;
  expiredAt: Date;
  createdAt: Date;
  username?: string;
  permissions: Permission[];
  partnerPermissions?: PartnerPermission[];
}

export enum UserType {
  seller = 'SELLER',
  buyer = 'BUYER',
  debtor = 'DEBTOR',
  partner = 'PARTNER',
  partnerBranchMaster = 'PARTNER_BRANCH_MANAGER',
  partnerAgent = 'PARTNER_AGENT',
}

export enum Permission {
  Bid = 'Bid', // consente di fare un'offerta a un'asta
  ProfileUpdate = 'ProfileUpdate', // consente l'aggiornamento del profilo
  ReportDownload = 'ReportDownload', // consente il download dei report
  All = 'All', // enables ALL permissions (for admin)
}

export enum PartnerPermission {
  Accounts = 'Accounts', // Accesso sezione Gestione utenti
  AccountCreate = 'AccountCreate', // Possibilità di censire utenti

  Companies = 'Companies', // Accesso sezione Aziende
  CompanyDetail = 'CompanyDetail', // Visualizzazione dettaglio azienda

  SellerCreate = 'SellerCreate', // Possibilità di censire aziende
  DebtorCreate = 'DebtorCreate', // Possibilità di censire debtor

  Invoices = 'Invoices', // Accesso sezione Fatture
  InvoicesExport = 'InvoicesExport', // Esportazione file Excel fatture cedute

  TrustRequired = 'TrustRequired', // Visualizzazione fido richiesto
  TrustRequiredEdit = 'TrustRequiredEdit', // Inserimento fido richiesto
  CustomersExport = 'CustomersExport', // Esportazione lista clienti/fornitori
  CompanyInvoicesExport = 'CompanyInvoicesExport', // Esportazione lista fatture nel dettaglio azienda
  DebtorParameters = 'DebtorParameters', // Accesso sezione Parametri in Debtor

  CompanyCustomerDetails = 'CompanyCustomerDetails', // Visualizzazione data, tipologia di cessione e fido concesso (in clienti/fornitori)

  Documents = 'Documents', // Caricamento documenti

  All = 'All' // Tutti i permessi
}
